import { useBreakpointValue } from "@gluestack-style/react";
import { MenuActionItemProps } from "@repo/core/components/layout/MenuActionsList/components/MenuActionItem/types";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import { ROUTES } from "@repo/core/routes";
import { operationTypeEnum } from "./types";

export const CancelTransactionOptionsController = () => {
  const { back, push } = useNavigation();
  const isMobile = useBreakpointValue({ base: true, md: false });
  const menuActionItems: MenuActionItemProps[] = [
    {
      title: "Cancelar Compra ou Saque",
      onPress: () =>
        push(ROUTES.cancelTransaction, {
          operationType: operationTypeEnum.PURCHASE_WITHDRAWAL
        })
    },
    {
      title: "Cancelar Pontuação",
      onPress: () =>
        push(ROUTES.cancelTransaction, {
          operationType: operationTypeEnum.PONTUATION
        })
    }
    // {
    //   title: "Cancelar Pagamento",
    //   onPress: () => {
    //     //push(ROUTES.cancelTransaction)
    //   }
    // }
  ];
  return { back, isMobile, menuActionItems };
};
